import axios from 'axios'

const baseURL = process.env.VUE_APP_ADMIN_SERVER

export default {
  namespaced: true,
  state: {
    user: localStorage.getItem('admin-user') ? JSON.parse(localStorage.getItem('admin-user')) : null,
    api_token: `Bearer ${localStorage.getItem('token') || ''}`
  },
  getters: {
    hasPermission: state => permissionName => {
      return state.user && state.user.permissions.includes(permissionName)
    }
  },
  mutations: {
    setUser (state, payload) {
      state.user = payload
      localStorage.setItem('admin-user', JSON.stringify(payload))
    },
    setApiToken (state, token) {
      state.api_token = token
      axios.defaults.headers.common.Authorization = 'Bearer ' + token
      localStorage.setItem('token', token)
    }
  },
  actions: {
    async loginRequest ({ commit }, data) {
      const promise = axios.post(baseURL + '/api/login', data)

      promise.then(response => {
        commit('setUser', response.data.user)
        commit('setApiToken', response.data.token)
      })

      return promise
    },
    async getUser ({ commit }) {
      const promise = axios.get(baseURL + '/api/auth')

      promise.then(response => {
        commit('setUser', response.data.data)
      }).catch(error => {
        if (error.response.status === 401 && window.location.pathname !== '/') {
          localStorage.setItem('token', null)
          window.location = '/'
        }
      })

      return promise
    },
    async updateProfile ({ commit }, data) {
      const promise = axios.put(baseURL + '/api/profile', data)

      promise.then(response => {
        commit('setUser', response.data.data)
      }).catch(error => {
        if (error.response.status === 401 && window.location.pathname !== '/') {
          localStorage.setItem('token', null)
          window.location = '/'
        }
      })

      return promise
    },
    logout ({ commit }) {
      axios.delete(baseURL + '/api/logout').then(response => {
        commit('setUser', null)
        localStorage.setItem('token', null)
        window.location = '/'
      })
    }
  }
}
